// Learners' own uploads (access-request receipts, refresher certificates)
// live in a private bucket. Records store a `learner-uploads/<object>`
// reference instead of a URL; viewers sign it on demand.

export const LEARNER_UPLOADS_BUCKET = "learner-uploads";

const REF_PREFIX = `${LEARNER_UPLOADS_BUCKET}/`;

export const toLearnerUploadRef = (objectPath) => `${REF_PREFIX}${objectPath}`;

/** Object path inside the bucket, or null for legacy URLs / anything else. */
export const parseLearnerUploadRef = (value) =>
  typeof value === "string" &&
  value.startsWith(REF_PREFIX) &&
  value.length > REF_PREFIX.length &&
  !value.includes("..")
    ? value.slice(REF_PREFIX.length)
    : null;

/** Only http(s) legacy links are opened directly. */
export const isOpenableLegacyUrl = (value) =>
  typeof value === "string" && /^https?:\/\//i.test(value);
